<div fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" style="margin-bottom: 32px">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4324 17.2981L7.35882 17.2952V13.7521C7.35882 12.995 7.66343 12.601 8.33539 12.511H10.4324C11.9279 12.511 12.8953 13.42 12.8953 14.8913C12.8953 16.4024 11.9524 17.2967 10.4324 17.2981H10.4324ZM7.35882 7.74154V6.8089C7.35882 5.99285 7.71699 5.60474 8.50223 5.55457H10.0758C11.4243 5.55457 12.2325 6.33225 12.2325 7.6353C12.2325 8.62696 11.6784 9.78538 10.1247 9.78538H7.35882V7.74154ZM14.357 11.2773L13.8014 10.9763L14.2866 10.5763C14.8514 10.1085 15.7974 9.05638 15.7974 7.24128C15.7974 4.46108 13.5611 2.66811 10.1002 2.66811H6.15112V2.66663H5.7011C4.67555 2.70352 3.85359 3.50778 3.84287 4.5024V20.2776H10.1783C14.0249 20.2776 16.5076 18.2588 16.5076 15.1318C16.5076 13.448 15.7056 12.0092 14.357 11.2773Z"
      fill="#0C3B7C" />
    <path
      d="M18.1583 18.0986C18.1583 16.8935 19.1664 15.9186 20.4086 15.9186C21.6538 15.9186 22.6667 16.8935 22.6667 18.0986C22.6667 19.3022 21.6538 20.2786 20.4085 20.2786C19.1664 20.2786 18.1583 19.3022 18.1583 18.0986Z"
      fill="#00AFF1" />
  </svg>
  <h2 class="nomargin">Once your Booking.com connection is complete:</h2>
</div>

<div style="padding-top: 32px">
  <h3>Enter your Booking.com account email</h3>
  <p class="subtitle">This is the email you used to log in to your Booking.com account.</p>

  <mat-form-field class="fw" id="search-input">
    <input
      type="search"
      data-intercom-target="booking-com-credentials-input"
      [(ngModel)]="email"
      matInput
      type="email"
      autofocus />
    <button mat-button *ngIf="email" matSuffix mat-icon-button aria-label="Clear" (click)="email = ''">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div style="padding-top: 32px">
  <h3>Enter the accommodation IDs for all connected properties</h3>
  <p class="subtitle">
    <a
      target="_blank"
      href="https://help.hospitable.com/en/articles/8889989-where-to-find-your-booking-com-accommodation-id"
      class="link">
      Where to find your Booking.com accommodation ID?
    </a>
  </p>

  <form [formGroup]="propertyIdsForm">
    <div
      formArrayName="propertyIds"
      fxLayout
      fxLayoutAlign="space-between center"
      style="margin-bottom: 16px"
      fxLayoutGap="16px"
      *ngFor="let propertyId of propertyIds.controls; let i = index">
      <mat-form-field class="fw nopadding nomargin" [id]="'property-ids-' + i">
        <mat-label>Accommodation ID for Property {{ i + 1 }}</mat-label>
        <input [formControlName]="i" placeholder="Eg. 8792186" matInput type="number" />
        <button
          mat-button
          *ngIf="i > 0"
          matSuffix
          mat-icon-button
          aria-label="Remove"
          (click)="removePropertyIdField(i)">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </form>

  <sbnb-button
    label="+ Add more"
    [fullWidth]="true"
    size="mini"
    type="secondary"
    (click)="addPropertyIdField()"></sbnb-button>
</div>

<div style="margin-top: 16px" fxLayout fxLayoutGap="10px" fxLayoutAlign="end center">
  <sbnb-button label="Back" type="secondary" (click)="back()"></sbnb-button>
  <sbnb-button
    data-intercom-target="booking-com-property-ids-continue"
    label="Continue"
    [disabled]="this.propertyIdsForm.invalid || !email"
    [loading]="loading"
    (click)="progress()"></sbnb-button>
</div>
